<template>
  <div class="componentLoader">
    <span class="componentLoaderSpinner"></span>
  </div>
</template>

<script>
export default {
  name: "loader",
};
</script>

<style scoped>
.componentLoader {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.componentLoaderSpinner {
  border: 4px solid rgba(8, 33, 255, 0.2);
  border-top: 4px solid #0821ff;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  animation: componentLoaderSpinner 1s linear infinite;
}

@keyframes componentLoaderSpinner {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
